export default __webpack_public_path__ + "f51847a9cd70ef5aaf0d5705389ed2d4.png";